import clsx from "clsx";
import { TooltipTrigger } from "react-aria-components";
import { buttonStyles } from "../../buttons/Button/Button.recipe";
import iconButtonStyles from "../../buttons/IconButton/IconButton.module.css";
import { TooltipBubble } from "../../tooltips/TooltipBubble";
import BaseLink from "../BaseLink";
import { IconButtonLinkProps } from "./types";

const IconButtonLink = ({
  appearance,
  className,
  icon,
  label,
  tooltip = false,
  ...props
}: IconButtonLinkProps) => {
  const link = (
    <BaseLink
      {...props}
      aria-label={label}
      className={clsx(
        buttonStyles({
          appearance,
          shape: "circle",
        }),
        iconButtonStyles.iconButtonBase,
        className,
      )}
    >
      {icon}
    </BaseLink>
  );

  if (!tooltip) {
    return link;
  }

  return (
    <TooltipTrigger delay={100}>
      {link}
      <TooltipBubble>
        <span aria-hidden="true">{label}</span>
      </TooltipBubble>
    </TooltipTrigger>
  );
};

export default IconButtonLink;
